export const PERIODS = [
    { id: 1, time: '08:10-09:00' },
    { id: 2, time: '09:10-10:00' },
    { id: 3, time: '10:10-11:00' },
    { id: 4, time: '11:10-12:00' },
    { id: 'N', time: '12:10-13:00' },
    { id: 5, time: '13:10-14:00' },
    { id: 6, time: '14:10-15:00' },
    { id: 7, time: '15:10-16:00' },
    { id: 8, time: '16:10-17:00' },
    { id: 9, time: '17:10-18:00' },
    { id: 'A', time: '18:30-19:20' },
    { id: 'B', time: '19:20-20:10' },
    { id: 'C', time: '20:20-21:10' },
    { id: 'D', time: '21:10-22:00' },
];
